// extracted by mini-css-extract-plugin
export default {"container":"UploadDocuments_container__-HHCM"};